import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-delivery-details',
  templateUrl: './delivery-details.component.html',
  styleUrls: ['./delivery-details.component.scss'],
})
export class DeliveryDetailsComponent implements OnInit {

  @Input() public product: any;
  @Input() public redemption: any;

  deliveryForm: FormGroup;

  get errorControl() {
    return this.deliveryForm.controls;
  }

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastController: ToastController,
    private firestore: AngularFirestore
  ) { }

  ngOnInit() {
    console.log('DeliveryDetailsComponent initialized with product:', this.product, 'redemption:', this.redemption);
    this.deliveryForm = this.formBuilder.group({
      deliveryAddress: ['', [Validators.required, Validators.minLength(10)]],
      nearbyLocation: ['', [Validators.required, Validators.minLength(3)]],
      phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      whatsappNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]]
    });
  }

  async submitDeliveryDetails() {
    console.log('Submitting delivery details, form valid:', this.deliveryForm.valid);
    if (this.deliveryForm.valid) {
      const currentUser = this.authService.currentAccount.value;
      const deliveryData = {
        ...this.deliveryForm.value,
        status: 'delivery_requested',
        deliveryRequestedAt: new Date()
      };

      // Create delivery request document
      const deliveryRequestData = {
        userId: currentUser?.id,
        userEmail: currentUser?.email,
        userName: currentUser?.name || currentUser?.displayName,
        productId: this.product?.id,
        productName: this.product?.name,
        productType: this.product?.type,
        productCoins: this.product?.coins,
        redemptionId: this.redemption?.id,
        deliveryAddress: this.deliveryForm.value.deliveryAddress,
        nearbyLocation: this.deliveryForm.value.nearbyLocation,
        phoneNumber: this.deliveryForm.value.phoneNumber,
        whatsappNumber: this.deliveryForm.value.whatsappNumber,
        status: 'delivery_requested',
        deliveryRequestedAt: new Date(),
        createdAt: new Date()
      };

      try {
        // Create document in deliveryRequests collection
        await this.firestore.collection('deliveryRequests').add(deliveryRequestData);

        // Update the redemption record with delivery details
        await this.firestore.collection('ledger').doc(this.redemption.id).update(deliveryData);

        this.presentToast('Success', 'Delivery details submitted successfully!');
        this.modalCtrl.dismiss(deliveryData);
      } catch (error) {
        console.error('Error submitting delivery details:', error);
        this.presentToast('Error', 'Failed to submit delivery details. Please try again.');
      }
    } else {
      this.presentToast('Invalid Form', 'Please fill all required fields correctly');
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(header: string, message: string) {
    const toast = await this.toastController.create({
      header,
      message,
      position: 'middle',
      cssClass: 'spcl-toast',
      duration: 2000
    });
    await toast.present();
  }

}
